import { useEffect, useRef } from "react";
import { useSensorsMap } from "../../contexts/SensorsMapProvider";
import { typeDetails } from "../../utils/sensors";

export const LoopMapMonitor = () => {
	const { state, dispatch, ACTIONS } = useSensorsMap();
	const currentTypeIndexRef = useRef(0);

	useEffect(() => {
		const selectedIds = [process.env.ID_PIN_GROUP_SENSORI || 11, 13];
		if (!state?.pinsGroups) return;

		const isCorrectlySelected = state.pinsGroups.every(
			(group) =>
				(selectedIds.includes(group.id) && group.selected === 1) ||
				(!selectedIds.includes(group.id) && group.selected === 0)
		);

		if (!isCorrectlySelected) {
			dispatch({ type: ACTIONS.SET_SELECTED_GROUPS, payload: selectedIds });
		}
	}, [state.pinsGroups, dispatch, ACTIONS]);

	useEffect(() => {
		const typeKeys = Object.keys(typeDetails);
		if (!typeKeys || typeKeys.length === 0) return;

		dispatch({
			type: ACTIONS.SET_SELECTED_TYPE,
			payload: typeDetails[typeKeys[currentTypeIndexRef.current]],
		});

		const interval = setInterval(() => {
			currentTypeIndexRef.current = (currentTypeIndexRef.current + 1) % typeKeys.length;

			dispatch({
				type: ACTIONS.SET_SELECTED_TYPE,
				payload: typeKeys[currentTypeIndexRef.current],
			});
		}, 3000);

		return () => clearInterval(interval);
	}, [ACTIONS, dispatch]);

	return null;
};
